import './ReportPreviewItems.scss'
import { ReportBlockBarChartPreview, CustomTextPreview, CommentsBlockPreview, GridBlocksEnum } from '../blocks'

export function ReportPreviewItems({ items = [] }) {
  return (
    <div>
      {items
        .filter(({ visible }) => visible)
        .map((item, index) => (
          <div key={`${item.type}-${item.id || index}`}>{renderPreview(item)}</div>
        ))}
    </div>
  )
}

const renderPreview = ({ type, id, content = {}, config = {} }) => {
  if (type === GridBlocksEnum.CUSTOM_CHART) {
    return <ReportBlockBarChartPreview title={config.title} data={content.data} showLegend={config.legend} />
  }
  if (type === GridBlocksEnum.CUSTOM_TEXT) {
    return <CustomTextPreview document={{ id, content: config.content }} />
  }
  if (type === GridBlocksEnum.COMMENTS) {
    return <CommentsBlockPreview title={config.title} dateRange={{ from: config.from, to: config.to }} criteriaComments={content?.criteriaComments || []} />
  }

  console.error(`No preview available for type ${type}`)
  return <></>
}
